import { render, staticRenderFns } from "./StepExtras.vue?vue&type=template&id=24993af6&scoped=true"
import script from "./StepExtras.vue?vue&type=script&lang=js"
export * from "./StepExtras.vue?vue&type=script&lang=js"
import style0 from "./StepExtras.vue?vue&type=style&index=0&id=24993af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24993af6",
  null
  
)

export default component.exports